//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'StoolOsmoticGap',
  data () {
    return {
      form: {
        osmoticNa: '',
        osmoticK: '',
        osmoticDiff: ''
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        let result = form.osmoticDiff - 2 * (form.osmoticNa + form.osmoticK)
        if (result > 125) {
          self.descTxt = '渗透性腹泻'
        } else if (result < 50) {
          self.descTxt = '分泌性腹泻'
        } else {
          self.descTxt = '存在不确定性'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/StoolOsmoticGap.vue